import { Reveal, SectionHeading } from "./Reveal";
import { Award, ShoppingCart } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

export const About = () => {
  const { t } = useLang();

  const PILLARS = [
    { icon: Award, n: "01", title: t("about.p1t"), desc: t("about.p1d") },
    { icon: ShoppingCart, n: "02", title: t("about.p2t"), desc: t("about.p2d") },
  ];

  return (
    <section id="about" data-testid="about-section" className="relative py-20 lg:py-28 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow={t("about.eyebrow")}
          title={
            <>
              {t("about.titleA")}
              <span className="text-blue-700">{t("about.titleB")}</span>
              {t("about.titleC") || ""}
            </>
          }
          sub={t("about.sub")}
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="space-y-4 order-2 lg:order-1">
            {PILLARS.map((p, i) => (
              <Reveal key={p.n} delay={i * 0.12}>
                <div
                  data-testid={`about-pillar-${p.n}`}
                  className="group flex gap-5 p-6 rounded-2xl border border-slate-200/80 bg-slate-50/60 hover:bg-white hover:border-blue-300 hover:shadow-[0_16px_40px_-16px_rgba(29,78,216,0.25)] transition-all duration-400"
                >
                  <div className="shrink-0 grid place-items-center w-12 h-12 rounded-xl bg-blue-700/10 text-blue-700 group-hover:bg-blue-700 group-hover:text-white transition-colors duration-300">
                    <p.icon className="w-5 h-5" />
                  </div>
                  <div>
                    <p className="font-mono text-[11px] font-bold tracking-[0.2em] text-slate-400">{p.n}</p>
                    <h3 className="mt-1 text-lg font-bold text-slate-900">{p.title}</h3>
                    <p className="mt-1.5 text-sm text-slate-500 leading-relaxed">{p.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.15} className="order-1 lg:order-2">
            <div className="relative">
              <div className="absolute -inset-4 rounded-[2rem] border border-blue-200/70 pointer-events-none" />
              <div className="relative rounded-3xl overflow-hidden border border-slate-200 shadow-[0_30px_60px_-24px_rgba(15,23,42,0.3)]">
                <img
                  src="https://images.pexels.com/photos/17489160/pexels-photo-17489160.jpeg?auto=compress&cs=tinysrgb&h=650&w=940"
                  srcSet="https://images.pexels.com/photos/17489160/pexels-photo-17489160.jpeg?auto=compress&cs=tinysrgb&w=480 480w, https://images.pexels.com/photos/17489160/pexels-photo-17489160.jpeg?auto=compress&cs=tinysrgb&w=940 940w, https://images.pexels.com/photos/17489160/pexels-photo-17489160.jpeg?auto=compress&cs=tinysrgb&w=1400 1400w"
                  sizes="(max-width: 1024px) 100vw, 50vw"
                  alt="Secure datacenter infrastructure powering quantum-safe networks"
                  className="w-full h-[420px] sm:h-[480px] object-cover"
                  loading="lazy"
                  width="940"
                  height="650"
                  decoding="async"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/55 via-transparent to-transparent" />
                <div className="absolute bottom-5 left-5 right-5 flex flex-wrap gap-2.5">
                  {["ISO 27001 READY", "GeM REGISTERED", "MAKE IN INDIA PARTNER"].map((tag) => (
                    <span key={tag} className="text-[10px] font-mono font-bold tracking-[0.16em] text-white bg-white/15 backdrop-blur-md border border-white/30 px-3 py-1.5 rounded-full">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
              <div className="absolute -top-5 -right-3 sm:-right-6 bg-white border border-slate-200 rounded-2xl shadow-[0_16px_40px_-16px_rgba(15,23,42,0.25)] px-5 py-4">
                <p className="font-mono text-2xl font-extrabold text-blue-700">2031</p>
                <p className="text-[11px] font-semibold text-slate-500 mt-0.5">{t("about.badgeA")}<br />{t("about.badgeB")}</p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
